"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductBuilderFooter = void 0;
const React = require("react");
const Modal_1 = require("../../../../../../components/base/structure/Modal");
const cloneModelObject_1 = require("../../../../../../apis/spg/util/cloneModelObject");
const ChangeProductQuantity_1 = require("../../../atoms/ChangeProductQuantity");
const CompleteProductBuildButton_1 = require("../CompleteProductBuildButton");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "ProductBuilderFooter");
const ProductBuilderFooter = ({ salesOrderItemBuilt, scrollToCategory, isExisting, setSalesOrderItem, onCompletion }) => {
    // function to update the current product being built quantity
    const updateProductQuantity = (quantity) => {
        // if not a number because we use text input then convert it
        if (typeof quantity !== "number") {
            quantity = Number(quantity);
        }
        // update item quantity
        salesOrderItemBuilt.quantity = quantity;
        // update item
        // need to clone so ui is refreshed
        setSalesOrderItem((0, cloneModelObject_1.cloneModelObject)(salesOrderItemBuilt));
    };
    return (React.createElement(Modal_1.ModalFooter, { className: css("") },
        React.createElement("div", { className: css("container") },
            React.createElement("div", { className: css("container_changeProductQty") },
                React.createElement(ChangeProductQuantity_1.ChangeProductQuantity, { salesOrderItem: salesOrderItemBuilt, onInputChange: updateProductQuantity })),
            React.createElement(CompleteProductBuildButton_1.CompleteProductBuildButton, { salesOrderItemBuilt: salesOrderItemBuilt, onCompletion: onCompletion, isExisting: isExisting, scrollToCategory: scrollToCategory }))));
};
exports.ProductBuilderFooter = ProductBuilderFooter;
//# sourceMappingURL=index.js.map